/**
 * String key that carries API call info interpreted by this Redux middleware.
 *
 * @constant {string}
 * @access public
 * @default
 */
const RSAA = '@@redux-api-middleware/RSAA';

export default RSAA;